import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { IssueFormAttributes } from "@adsk/acc-issues-core/utils/types/Issue";

export const useScrollToAttachmentErrorInCreationForm = (
  ref: React.MutableRefObject<HTMLDivElement | null>
) => {
  const { errors, isSubmitting } = useFormikContext<IssueFormAttributes>();
  useEffect(() => {
    if (errors.attachments && ref.current && isSubmitting) {
      const attachmentsField = ref.current.querySelector(
        "[data-testid='attachments-field']"
      );
      attachmentsField?.scrollIntoView();
    }
  }, [errors, ref, isSubmitting]);
};
